import { namespace } from 'vuex-class';
import { BindingHelpers } from 'vuex-class/lib/bindings';
import { IDeletePageState } from './delete-page.types';

export const DeletePage: BindingHelpers = namespace('documentManipulator/deletePage');

export const getDefaultState: () => IDeletePageState = () => ({
  deletedPageId: null,
  deleting: false,
  deleteFailed: false,
  pageToBeDeleted: null,
});

export enum EDeletePageAction {
  Delete = 'delete',
  DeleteSuccess = 'deleteSuccess',
  DeleteFailed = 'deleteFailed',
  Reset = 'reset',
}

export enum EDeletePageMutation {
  SetDeletedPageId = 'setDeletedPageId',
  SetDeleting = 'setDeleting',
  SetDeleteFailed = 'setDeleteFailed',
  SetPageToBeDeleted = 'setPageToBeDeleted',
  SetState = 'setState',
}
